import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Box, MinusThinIcon, PlusThinIcon, RawButton } from '@common-fe/common-fe';
import styled from 'styled-components';

const Wrapper = styled(Box)`
  transform-origin: top left;
`;
interface ButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  testId: string;
}
const ZoomButton: React.FC<ButtonProps> = ({ onClick, children, testId }) => {
  return (
    <RawButton data-testid={`${testId}_button`} onClick={onClick}>
      <Box
        round="button1Round"
        align="center"
        justify="center"
        width="40px"
        height="40px"
        background="background1"
      >
        {children}
      </Box>
    </RawButton>
  );
};
interface Props {
  children: React.ReactNode;
  disabled?: boolean;
  controlsContainer?: HTMLElement | null;
}

const STEP = 0.2;
const MIN_ZOOM_OUT = 0.2;

const ScanZoomer: React.FC<Props> = ({ children, disabled, controlsContainer }) => {
  const [currentScale, setCurrentScale] = useState(1);

  const zoomIn = () => {
    setCurrentScale(currentScale + STEP);
  };
  const zoomOut = () => {
    if (currentScale > MIN_ZOOM_OUT) {
      setCurrentScale(currentScale - STEP);
    }
  };
  if (disabled) {
    return children;
  }
  const controls = (
    <Box
      direction="column"
      gap="spacing4"
      style={controlsContainer ? undefined : { position: 'absolute', top: 0, right: 0, zIndex: 100 }}
      data-testid="scan-zoomer-controls"
    >
      <ZoomButton onClick={zoomIn} testId="zoom-in">
        <PlusThinIcon color="iconOnColor" />
      </ZoomButton>
      <ZoomButton onClick={zoomOut} testId="zoom-out">
        <MinusThinIcon color="iconOnColor" />
      </ZoomButton>
    </Box>
  );
  return (
    <>
      {controlsContainer ? createPortal(controls, controlsContainer) : controls}
      <Wrapper
        style={{
          transform: `scale(${currentScale})`,
        }}
        data-testid="scan-zoomer-content"
      >
        {children}
      </Wrapper>
    </>
  );
};

export default ScanZoomer;
